export default class Billing {
    constructor() {
        this.id;
        this.billingId
        this.invoiceNumber;
        this.invoiceFileId;
        this.createdByUserId;
        this.isDeleted;
        this.createdAt;
        this.customerExchangeObject;
        this.invoiceRetrieveObject;
        this.accountId;
        this.linkUrl;
        this.isFinal;
        this.medediStatus;
        this.localBillingStatus;
        this.placeOfService = 0;
        this.hasReferringDr;
        this.referringDrName;
        this.referringDrMpnum;
        this.referringDrPracticeNum;
        this.dateOfService;
        this.customerExchangeRequestObject;
        this.invoiceRetrieveRequestObject;
        this.referralLetterFileId;

        this.iaInitialClinicalPresentationAndTreatmentPlan;
        this.iaHasPreExistingConditions;
        this.iaPreExistingConditions;
        this.iaInvestigationAndResults;
        this.iaDiagnosis;
        this.iaTreatmentPlan;
        this.iaTreatedInTheater;
        this.iaTheaterReport;
        this.iaDischarged;
        this.iaFollowUpPlanned;
        this.iaFollowUpDate;
        this.iaGeneralNotes;
        this.iaIsSaved;

        this.prFollowUpDate;
        this.prCurrtentConditionTreatmentPlan;
        this.prWasInTheater;
        this.prTheaterReport;
        this.prInvestigations;
        this.prDischarged;
        this.prFollowUpPlanned;
        this.prFollowUpPlannedDate;
        this.prGeneralNotes;
        this.prIsSaved;

      
        this.arDiagnosis;
        this.arPreAssessment;
        this.arDischarged;
        this.arProcedure;
        this.arSurgeon;
        this.arTheaterTimeIn;
        this.arTheaterTimeOut;
        this.arSpinalGeneral;
        this.arDrugsUsed;
        this.arIntubation;
        this.arBloodLoss;
        this.arComplications;
        this.arGeneralNotes;
        this.arIsSaved;

        this.billingItemFiles;
    }
  
    set(setEntity) {
      this.id = setEntity.id;
      this.billingId = setEntity.billingId;
      this.invoiceNumber = setEntity.invoiceNumber;
      this.invoiceFileId = setEntity.invoiceFileId;
      this.createdByUserId = setEntity.createdByUserId;
      this.isDeleted = setEntity.isDeleted;
      this.createdAt = setEntity.createdAt;
      this.customerExchangeObject = setEntity.customerExchangeObject;
      this.invoiceRetrieveObject = setEntity.invoiceRetrieveObject;
      this.accountId = setEntity.accountId;
      this.linkUrl = setEntity.linkUrl;
      this.isFinal = setEntity.isFinal;
      this.medediStatus = setEntity.medediStatus;
      this.localBillingStatus = setEntity.localBillingStatus;
      this.placeOfService = setEntity.placeOfService;
      this.hasReferringDr = setEntity.hasReferringDr;
      this.referringDrName = setEntity.referringDrName;
      this.referringDrMpnum = setEntity.referringDrMpnum;
      this.referringDrPracticeNum = setEntity.referringDrPracticeNum;
      this.dateOfService = setEntity.dateOfService;
      this.customerExchangeRequestObject = setEntity.customerExchangeRequestObject;
      this.invoiceRetrieveRequestObject = setEntity.invoiceRetrieveRequestObject;
      this.referralLetterFileId = setEntity.referralLetterFileId;

      this.iaInitialClinicalPresentationAndTreatmentPlan = setEntity.iaInitialClinicalPresentationAndTreatmentPlan;
      this.iaHasPreExistingConditions = setEntity.iaHasPreExistingConditions;
      this.iaPreExistingConditions = setEntity.iaPreExistingConditions;
      this.iaInvestigationAndResults = setEntity.iaInvestigationAndResults;
      this.iaDiagnosis = setEntity.iaDiagnosis;
      this.iaTreatmentPlan = setEntity.iaTreatmentPlan;
      this.iaTreatedInTheater = setEntity.iaTreatedInTheater;
      this.iaTheaterReport = setEntity.iaTheaterReport;
      this.iaDischarged = setEntity.iaDischarged;
      this.iaFollowUpPlanned = setEntity.iaFollowUpPlanned;
      this.iaFollowUpDate = setEntity.iaFollowUpDate;
      this.iaGeneralNotes = setEntity.iaGeneralNotes;
      this.iaIsSaved = setEntity.iaIsSaved;
      this.prFollowUpDate = setEntity.prFollowUpDate;
      this.prCurrtentConditionTreatmentPlan = setEntity.prCurrtentConditionTreatmentPlan;
      this.prWasInTheater = setEntity.prWasInTheater;
      this.prTheaterReport = setEntity.prTheaterReport;
      this.prInvestigations = setEntity.prInvestigations;
      this.prDischarged = setEntity.prDischarged;
      this.prFollowUpPlanned = setEntity.prFollowUpPlanned;
      this.prFollowUpPlannedDate = setEntity.prFollowUpPlannedDate;
      this.prGeneralNotes = setEntity.prGeneralNotes;
      this.prIsSaved = setEntity.prIsSaved;
      this.arDiagnosis = setEntity.arDiagnosis;
      this.arPreAssessment = setEntity.arPreAssessment;
      this.arDischarged = setEntity.arDischarged;
      this.arProcedure = setEntity.arProcedure;
      this.arSurgeon = setEntity.arSurgeon;
      this.arTheaterTimeIn = setEntity.arTheaterTimeIn;
      this.arTheaterTimeOut = setEntity.arTheaterTimeOut;
      this.arSpinalGeneral = setEntity.arSpinalGeneral;
      this.arDrugsUsed = setEntity.arDrugsUsed;
      this.arIntubation = setEntity.arIntubation;
      this.arBloodLoss = setEntity.arBloodLoss;
      this.arComplications = setEntity.arComplications;
      this.arGeneralNotes = setEntity.arGeneralNotes;
      this.arIsSaved = setEntity.arIsSaved;

      this.billingItemFiles = setEntity.billingItemFiles ? setEntity.billingItemFiles : [];

      return this;
    }
  }